var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillsInitialsL(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12985_10675)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 768,
    transform: "translate(-456 -435)",
    fill: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-392 -39.5H504C508.142 -39.5 511.5 -36.1421 511.5 -32V32C511.5 36.1421 508.142 39.5 504 39.5H-392C-396.142 39.5 -399.5 36.1421 -399.5 32V-32C-399.5 -36.1421 -396.142 -39.5 -392 -39.5Z",
    fill: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-392 -39.5H504C508.142 -39.5 511.5 -36.1421 511.5 -32V32C511.5 36.1421 508.142 39.5 504 39.5H-392C-396.142 39.5 -399.5 36.1421 -399.5 32V-32C-399.5 -36.1421 -396.142 -39.5 -392 -39.5Z",
    stroke: "#838D90"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    rx: 12,
    fill: "#FDDBEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05639 17.6896C10.6765 15.713 11.9865 14.7247 13.5 14.7247C15.0136 14.7247 16.3236 15.713 18.9437 17.6896L19.9448 18.4448L19.1895 17.4437C17.213 14.8236 16.2247 13.5136 16.2247 12C16.2247 10.4865 17.213 9.17645 19.1895 6.55639L19.9448 5.55521L18.9437 6.31047C16.3236 8.28702 15.0136 9.27529 13.5 9.27529C11.9865 9.27529 10.6765 8.28702 8.05639 6.31047L7.05518 5.55518L7.81048 6.55638C9.78702 9.17645 10.7753 10.4865 10.7753 12C10.7753 13.5136 9.78702 14.8236 7.81048 17.4437L7.05521 18.4448L8.05639 17.6896Z",
    fill: "#C90D81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0169 16V7.27273H24.3337V14.8665H28.2882V16H23.0169Z",
    fill: "#071B22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12985_10675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 768,
    fill: "white",
    transform: "translate(-456 -435)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsInitialsL);
export default __webpack_public_path__ + "static/media/Skills Initials L.f871f7cf848faa2eaaceb2ca04af8c5b.svg";
export { ForwardRef as ReactComponent };